import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"
import { SelectToursStepUi } from "@src/widgets/onboarding/ui/tours/Welcome/steps/SelectToursStepUi"

export class SelectToursStep extends TourStepBase {
  component = SelectToursStepUi
  name = `${ONBOARDING_TOURS.SENDING_INVOICES}_SelectTours`

  constructor() {
    super({ placement: TOUR_MODAL_PLACEMENTS.CENTER })
  }

  action() {
    return Promise.resolve()
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Select the features you're interested in to learn more",
      title: "Personalize your tour",
    }
  }
}
